import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ContactAndAddressService } from '@services/contact-and-address/contact-and-address.service';
import { SelectContactDialogComponent } from './select-dialog/select-contact-dialog.component';
import { EditContactDialogComponent } from './edit-dialog/edit-contact-dialog.component';

@Component({
    selector: 'contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    providers: [ContactAndAddressService],
    standalone: false
})
export class ContactComponent implements OnInit {

  @Input() dynamicContent;
  @Input() contact;
  selectedAddress;
  selectedContact;

  constructor(private dialog: MatDialog, private contactAndAddressService: ContactAndAddressService) {
  }

  async ngOnInit() {
    if (!this.dynamicContent.content.location) {
      this.dynamicContent.content.location = {};
    }
    if (!this.dynamicContent.content.location.coordinates) {
      this.dynamicContent.content.location.coordinates = { latitude: null, longitude: null };
    }
    if (this.dynamicContent.attachedAddressId || this.dynamicContent.attachedContactId) {
      const ids = [this.dynamicContent.attachedAddressId, this.dynamicContent.attachedContactId].filter(Boolean);
      if (!ids.length) {
        return;
      }
      const addresses = (await this.contactAndAddressService.find(0, ids.length, { _id: { $in: ids } })).data;
      this.selectedContact = addresses.find(el => el._id === this.dynamicContent.attachedContactId);
      this.selectedAddress = addresses.find(el => el._id === this.dynamicContent.attachedAddressId);
    }
  }

  async addItem(type = 'contact', variant = 'select') {
    const data: any = { type };
    let result: any;
    if (variant === 'select') {
      data.titleTranslation = type === 'contact' ? 'contacts' : 'addresses';
      let dialogRef: MatDialogRef<SelectContactDialogComponent>;
      dialogRef = this.dialog.open(SelectContactDialogComponent, <any>{ width: '900px', height: '500px', data, panelClass: 'select-contact-modal' });
      result = await dialogRef.afterClosed().toPromise();
    } else {
      if ((!this.dynamicContent.attachedContactId && !this.dynamicContent.attachedAddressId) ||
        (type === 'contact' && !this.dynamicContent.attachedContactId) ||
        (type === 'address' && !this.dynamicContent.attachedAddressId)) {
        data.content = this.dynamicContent;
      }
      let dialogRef: MatDialogRef<EditContactDialogComponent>;
      dialogRef = this.dialog.open(EditContactDialogComponent, <any>{ width: '900px', data });
      result = await dialogRef.afterClosed().toPromise();
    }
    if (result?._id) {
      this[type === 'contact' ? 'selectedContact' : 'selectedAddress'] = await this.contactAndAddressService.get(result._id);
      if (type !== 'contact' && !this.selectedAddress.coordinates) {
        this.selectedAddress.coordinates = { latitude: null, longitude: null };
      }
      this.dynamicContent[type === 'contact' ? 'attachedContactId' : 'attachedAddressId'] = result._id;
    } else if (result === 'openNew') {
      await this.addItem(type, 'create');
    }
  }
}
